import { render, staticRenderFns } from "./form_assignment_template_component.vue?vue&type=template&id=2657150b&scoped=true"
import script from "./form_assignment_template_component.vue?vue&type=script&lang=js"
export * from "./form_assignment_template_component.vue?vue&type=script&lang=js"
import style0 from "./form_assignment_template_component.vue?vue&type=style&index=0&id=2657150b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2657150b",
  null
  
)

export default component.exports